<mat-card appearance="outlined">
    <div class="spinner-div" *ngIf="isLoading; else isNotLoading"><mat-spinner mode="indeterminate" [diameter]="50" color="primary"></mat-spinner></div>
    <ng-template #isNotLoading>
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" cdkDropList (cdkDropListDropped)="drop($event)">
          
          <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding cdkDrag
          [cdkDragData]="node" (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()" (cdkDragReleased)="dragEnd()">
            <button mat-icon-button disabled></button>
            {{stripHtml(node.name)}}
          </mat-tree-node>
      
          <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding cdkDrag [cdkDragData]="node" 
          (mouseenter)="dragHover(node)" (mouseleave)="dragHoverEnd()" (cdkDragStarted)="dragStart()" (cdkDragReleased)="dragEnd()">
            <button mat-icon-button matTreeNodeToggle
                    [attr.aria-label]="'toggle ' + node.filename">
              <mat-icon class="mat-icon-rtl-mirror">
                {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
              </mat-icon>
            </button>
            {{stripHtml(node.name)}} 
          </mat-tree-node>
      
        </mat-tree>
    </ng-template>
  </mat-card>